<template>
  <b-modal
    centered
    hide-header-close
    ref="value-help-modal-ref"
    size="lg"
    cancel-variant="outline-primary"
    :id="`${attrs.name}-modal-value-help`"
    :title="attrs.modalTitle || $t('global.form.select') + ` ${context.label}`"
    :ok-title="attrs.okTitle || $t('global.action.apply')"
    :cancel-title="attrs.cancelTitle || $t('global.action.cancel')"
    :ok-disabled="isEditing"
    @hidden="handleHide"
    @ok="handleApply"
  >
    <div class="mc-value-help">
      <LocalTable
        ref="table-modal-ref"
        :isBusy.sync="isBusy"
        :totalCount.sync="totalCount"
        :isEditing.sync="isEditing"
        :selectedModel="context.model"
        :fullObject="fullObject"
        :attrs="attrs"
        :multiple="multiple"
        :listGetter="attrs.listGetter"
        :geofenceAllData="geofenceAllData"
      >
        <template v-for="val in slotFields" v-slot:[val.name]="{ item }">
          <slot :name="val.name" :item="item"></slot>
        </template>
      </LocalTable>
      <Footer :totalCount="totalCount" />
    </div>
  </b-modal>
</template>

<script>
import LocalTable from './ModalBody/Table'
import Footer from './ModalBody/Footer'

export default {
  components: {
    LocalTable,
    Footer,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },

    attrs: {
      type: Object,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    fullObject: {},
    geofenceAllData: {},
  },
  emits: ['update:fullObject'],
  data() {
    return {
      isBusy: false,
      isEditing: false,
      totalCount: null,
    }
  },
  computed: {
    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },
  },
  methods: {
    handleAdd() {
      // show the custom modal
      if (this.attrs['has:createModal']) {
        this.$bvModal.show(`${this.attrs.name}-create-data-modal`)
        return
      }

      this.isEditing = true
      this.$refs['table-modal-ref'].HandleAdd()
    },
    handleHide() {
      this.totalCount = null
      this.isEditing = false

      this.context.blurHandler()
    },
    handleApply() {
      const { selectedValues, selectedObject, selectAll, exclude } =
        this.$refs['table-modal-ref'].HandleApply()
      // Filter out the selected values that are false (unselected)

      let fullObject
      if (this.multiple) {
        fullObject = selectedValues.map((selected) => {
          return selectedObject[selected]
        })
      } else {
        fullObject = selectedObject[selectedValues[0]] || {}
      }

      let exception = {
        selectAll: selectAll,
        exclude: exclude,
      }

      this.$emit('exception', exception)
      this.$emit('update:fullObject', fullObject)
      this.context.model = this.multiple ? selectedValues : selectedValues[0]

      this.context.blurHandler()
    },
  },
}
</script>
